import { GraphQLNonNull, GraphQLList, GraphQLID, GraphQLString } from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import { BaseAssessRule, baseAssessRule } from '../types/assess-rule'
import { ContrastQueryParameters } from '../endpoint-helpers'

interface BaseAssesRulesQueryArgs {
  readonly organizationID: string
  readonly applicationLanguage?: string
}

const baseAssesRulesQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  applicationLanguage: {
    description: 'The application language',
    type: GraphQLString
  }
}

export const normalizeAssessRule = ({ name, title }): BaseAssessRule => ({
  name,
  title
})

export const baseAssessRules: ContrastGraphQLFieldConfig<
  any,
  Context,
  BaseAssesRulesQueryArgs,
  BaseAssessRule[]
> = {
  description: 'Get all base assess rules',
  type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(baseAssessRule))),
  args: baseAssesRulesQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID, applicationLanguage } = args
    const { connector } = context

    const params = new ContrastQueryParameters()
    params.append('base', 'true')
    params.append('expand', 'skip_links')
    if (!!applicationLanguage) {
      params.append('quickFilter', applicationLanguage)
    }

    const { rules = [] } = await connector.get(
      `/${organizationID}/rules?${params}`
    )
    return rules.map(normalizeAssessRule)
  }
}
